import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'client/app/shared';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

import { RetirementPlanDocumentsComponent } from './retirement-plan-documents.component';
import { RetirementPlanDocumentsService } from './service/retirement-plan-documents.service';

import { PendingAcknowledgementsComponent } from './pending-acknowledgements/pending-acknowledgements.component';
import { PrintDistributionBatchComponent } from './print-distribution-batch/print-distribution-batch.component';

@NgModule({
  declarations: [
    RetirementPlanDocumentsComponent,
    PendingAcknowledgementsComponent,
    PrintDistributionBatchComponent
  ],
  providers: [
    RetirementPlanDocumentsService
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatPaginatorModule,
    BrowserModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    FormsModule,
    DatePickerModule
  ]
})
export class RetirementPlanDocumentsModule {}
